import { combineReducers } from 'redux';

import loaderReducer from './loader';
import loginReducer from './login';
import sidebarReducer from './sidebar';

const reducer = combineReducers<any>({
  loginReducer,
  sidebarReducer,
  loaderReducer,
});

export default reducer;
